/** Public invite to the Nocturne community / support server */
export const COMMUNITY_INVITE =
  process.env.REACT_APP_COMMUNITY_INVITE || "https://discord.gg/ZJMAWRPS3f";

export const COMMUNITY_NAME = "Nocturne";

/** Kami bot application id (Discord Developer Portal). */
export const KAMI_CLIENT_ID =
  process.env.REACT_APP_DISCORD_CLIENT_ID || "1284272082397433956";

/**
 * Guild bot invite only - bot + applications.commands.
 * Do not add response_type / redirect_uri here; those are for dashboard login
 * and make "Add App" look successful without installing the bot.
 */
export const BOT_INVITE_URL = `https://discord.com/api/oauth2/authorize?client_id=${KAMI_CLIENT_ID}&permissions=8&scope=bot%20applications.commands`;
